// extracted by mini-css-extract-plugin
export default {"Rcard":"ReferralCard_Rcard__ak3nl","ReferralTxt":"ReferralCard_ReferralTxt__jwS5W"};